import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function claimTitle(c) {
  if (!c) return "";
  const digits = String(c.agrn || "").replace(/agrn[-\s]*/i, "").trim();
  const desc = c.event_name || c.name || "";
  return digits ? `AGRN${digits} — ${desc}` : desc;
}
